/**
 * Types for reseller customers (not end users)
 */

export interface Customer {
  id: number;
  reseller_id: number;
  name: string;
  country_region: string;
  onboarding_date: string;
  platform_objective?: string;
  applicable_regulations?: string;
  business_owner_name: string;
  business_owner_email: string;
  technical_contact_name: string;
  technical_contact_email: string;
  main_communication_channel: 'email' | 'teams' | 'jira';
  support_schedule?: string;
  expected_sla?: string;
  observations?: string;
  created_at: string;
  updated_at: string;
  tenant_count?: number;
}

export interface CustomerCreate {
  reseller_id: number;
  name: string;
  country_region: string;
  onboarding_date?: string;
  platform_objective?: string;
  applicable_regulations?: string;
  business_owner_name: string;
  business_owner_email: string;
  technical_contact_name: string;
  technical_contact_email: string;
  main_communication_channel: 'email' | 'teams' | 'jira';
  support_schedule?: string;
  expected_sla?: string;
  observations?: string;
}

export interface CustomerUpdate {
  name?: string;
  country_region?: string;
  onboarding_date?: string;
  platform_objective?: string;
  applicable_regulations?: string;
  business_owner_name?: string;
  business_owner_email?: string;
  technical_contact_name?: string;
  technical_contact_email?: string;
  main_communication_channel?: string;
  support_schedule?: string;
  expected_sla?: string;
  observations?: string;
}

export interface CustomerSummary {
  id: number;
  name: string;
  reseller_id: number;
}

export interface CustomerList {
  customers: Customer[];
  total: number;
}

export const COMMUNICATION_CHANNELS = [
  { value: 'email', label: 'Email' },
  { value: 'teams', label: 'Microsoft Teams' },
  { value: 'jira', label: 'Jira' },
] as const;
